export type CancellationPolicyType = 'NO_REFUND' | 'FULL_REFUND' | 'PARTIAL_REFUND';

export type CancellationRequestStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

/** O que o atleta vê antes de pedir o cancelamento (GET /registrations/{id}/cancellation). */
export interface CancellationPreview {
  registrationId: number;
  registrationStatus: string;
  cancellable: boolean;
  notCancellableReason?: string;
  /** true: inscrição paga, vira pedido para o organizador; false: cancela na hora. */
  requiresApproval: boolean;
  policySummary: string;
  policyNotes?: string;
  amountPaid: number;
  refundAmount: number;
  requestStatus?: CancellationRequestStatus;
  organizerNote?: string;
}

/** Pedido de cancelamento como o organizador vê no painel. */
export interface CancellationRequestItem {
  id: number;
  registrationId: number;
  athleteName: string;
  athleteEmail: string;
  reason?: string;
  status: CancellationRequestStatus;
  amountPaid?: number;
  refundAmount: number;
  organizerNote?: string;
  createdAt: string;
  decidedAt?: string;
}

/** Mesmo texto que CancellationPolicyRules.describe na API, para a pré-visualização no formulário. */
export function describeCancellationPolicy(
  policy: CancellationPolicyType | null | undefined,
  deadlineDays?: number | null,
  percent?: number | null
): string {
  if (!policy || policy === 'NO_REFUND') {
    return 'Sem reembolso em caso de desistência.';
  }
  const days = deadlineDays ?? 0;
  const deadline = days === 0
    ? 'até a véspera do evento'
    : `até ${days} ${days === 1 ? 'dia' : 'dias'} antes do evento`;
  const amount = policy === 'FULL_REFUND' ? 'Reembolso integral' : `Reembolso de ${percent ?? 0}%`;
  return `${amount} ${deadline}. A taxa de serviço não é devolvida.`;
}
